import { useEffect, useRef } from "react";

export const Reveal = ({ as: Tag = "div", delay = 0, className = "", children, ...rest }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag ref={ref} className={`reveal ${className}`} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
};

export const SectionHead = ({ index, eyebrow, title, intro, light = false }) => (
  <Reveal className="grid gap-6 md:grid-cols-12 md:gap-10 mb-14 md:mb-20">
    <div className="md:col-span-4">
      <span className={`inline-flex items-center gap-3 whitespace-nowrap rounded-full border px-4 py-2 ${light ? "border-white/20" : "border-navy-200 bg-white"}`}>
        <span className={`text-xs font-bold tabular-nums ${light ? "text-bronze-300" : "text-bronze-600"}`}>{index}</span>
        <span className={`h-3 w-px ${light ? "bg-white/30" : "bg-navy-200"}`} />
        <span className={`text-[11px] uppercase tracking-[0.22em] font-semibold ${light ? "text-white" : "text-navy-900"}`}>{eyebrow}</span>
      </span>
    </div>
    <div className="md:col-span-8">
      <h2 className={`text-3xl sm:text-4xl lg:text-[2.75rem] font-bold tracking-tight leading-[1.1] ${light ? "text-white" : "text-navy-900"}`}>
        {title}
      </h2>
      {intro && (
        <p className={`mt-5 max-w-2xl text-base md:text-lg leading-relaxed ${light ? "text-navy-100" : "text-navy-500"}`}>{intro}</p>
      )}
    </div>
  </Reveal>
);
